const NBSP = " ";

export function money(value: number | null | undefined): string {
  return `${Math.round(value ?? 0).toLocaleString("ru-RU").replace(/\s/g, NBSP)}${NBSP}₽`;
}

/** Тон подложки под заглушку фотографии — стабильный для одного товара. */
const TINTS = ["#f7cfa2", "#d5e7b7", "#ded6ef", "#f6e3a6", "#f3c9c4", "#c8deea"];

export function tintFor(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) % 997;
  }
  return TINTS[hash % TINTS.length]!;
}

/** Монограмма из названия: «Парк Бургер» → «ПБ». */
export function monogram(title: string): string {
  return title
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0]?.toUpperCase() ?? "")
    .join("");
}

export function Photo({ src, title, className }: { src: string | null; title: string; className?: string }) {
  if (src) return <img src={src} alt={title} loading="lazy" />;

  return (
    <div className={`stub ${className ?? ""}`} style={{ background: tintFor(title) }} aria-hidden="true">
      {monogram(title)}
    </div>
  );
}

/** «Без лука» и «Лук» — оба варианта названия допустимы, приписка не дублируется. */
export function exclusionLabel(title: string): string {
  const trimmed = title.trim();
  return /^без\s/i.test(trimmed) ? trimmed : `без ${trimmed}`;
}

export function Spinner({ text }: { text: string }) {
  return (
    <div className="center">
      <div className="spinner" />
      <p className="muted">{text}</p>
    </div>
  );
}
